const welcome =
{
    connect     : 'Connectez vous !' ,
    description : 'Dévouvrez notre plateforme sécurisée et mutualisée pour manipuler et valoriser vos données ouvertes ou métiers.' ,
    title       : 'Bienvenue sur votre plateforme !'
};

export default welcome ;